/* eslint-disable no-unused-vars */
export enum DeliveryAddressFormFields {
  COUNTRY = 'country',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  INSTITUTION = 'companyName',
  ATTENTION = 'attention',
  ADDRESS_ONE = 'address1',
  ADDRESS_TWO = 'address2',
  CITY = 'city',
  STATE = 'state',
  POSTAL_CODE = 'postalCode',
  PHONE_NO = 'phoneNumber',
  IS_DEFAULT = 'active',
}

export enum ContactFormFields {
  EMAIL = 'email',
  PASSWORD = 'password',
  PROMO_CHECKBOX = 'promoCheckbox',
  IS_GUEST_CHECKOUT = 'isGuestCheckout',
  EMAIL_ERROR = 'emailError',
}

export const DeliveryAddressFormInitialState = {
  [DeliveryAddressFormFields.COUNTRY]: '',
  [DeliveryAddressFormFields.FIRST_NAME]: '',
  [DeliveryAddressFormFields.LAST_NAME]: '',
  [DeliveryAddressFormFields.INSTITUTION]: '',
  [DeliveryAddressFormFields.ATTENTION]: '',
  [DeliveryAddressFormFields.ADDRESS_ONE]: '',
  [DeliveryAddressFormFields.ADDRESS_TWO]: '',
  [DeliveryAddressFormFields.CITY]: '',
  [DeliveryAddressFormFields.STATE]: '',
  [DeliveryAddressFormFields.POSTAL_CODE]: '',
  [DeliveryAddressFormFields.PHONE_NO]: '',
  [DeliveryAddressFormFields.IS_DEFAULT]: false,
  isNewAddress: true,
};

export const ContactFormInitialState = {
  [ContactFormFields.EMAIL]: '',
  [ContactFormFields.PASSWORD]: '',
  [ContactFormFields.PROMO_CHECKBOX]: false,
  [ContactFormFields.IS_GUEST_CHECKOUT]: false,
  [ContactFormFields.EMAIL_ERROR]: '',
};
